import { redirect } from 'react-router';

import type { SubmittedInvoice } from '~/api/invoices/types';
import type { Params } from '~/providers/RouterProvider/router.types';

import { HttpNotFoundError } from '~/api/errors';
import { invoiceQueryOptions } from '~/api/invoices';
import { queryClient } from '~/providers/QueryClientProvider/queryClient';
import { r, routes } from '~/providers/RouterProvider/router.routes';

export const loader = async ({ params }: { params: Params<typeof routes.editInvoice> }): Promise<SubmittedInvoice> => {
  const invoiceId = Number(params.invoiceId);

  try {
    const invoice = await queryClient.ensureQueryData(invoiceQueryOptions(invoiceId));

    if (invoice.status !== 'LockedByUser') throw redirect(r(routes.showInvoice, { invoiceId: invoice.id }));

    return invoice;
  } catch (error) {
    if (error instanceof HttpNotFoundError) {
      throw redirect(routes.invoices);
    }

    throw error;
  }
};
